import React from 'react';
import * as S from './ClientInfo.styles';
import { IClient } from '@app/interfaces/client';

interface ClientInfoProps {
  client: IClient | null;
}

export const ClientInfo: React.FC<ClientInfoProps> = ({ client }) => {
  return (
    <S.Wrapper>
      {client && (
        <S.Content>
          <S.Title>{client?.name}</S.Title>
        </S.Content>
      )}
    </S.Wrapper>
  );
};
